// app/javascript/controllers/image_upload_controller.js
import { Controller } from "@hotwired/stimulus";
import { api } from "./api";

export default class extends Controller {
  static targets = [
    "input",
    "previewContainer",
    "container",
    "submitButton",
    "spinner",
  ];
  static values = {
    modelName: String,
    previewTemplate: String,
  };

  connect() {
    if (this.hasSubmitButtonTarget) {
      // this controller has two parts, one in a modal and section outside,
      // only the modal has the button target
      this.submitButtonTarget.disabled = true;
    }
  }

  disconnect() {}

  previewFiles(event) {
    const files = this.inputTarget.files;
    this.clearPreviews();
    this.selectedFiles = new DataTransfer();

    Array.from(files).forEach((file, index) => {
      const reader = new FileReader();
      reader.onload = (e) => this.addPreview(e.target.result, file, index);
      reader.readAsDataURL(file);
      this.selectedFiles.items.add(file);
    });

    // Update input with our managed FileList
    this.inputTarget.files = this.selectedFiles.files;
    this.submitButtonTarget.disabled = this.selectedFiles.files.length === 0;
  }

  addPreview(dataUrl, file, index) {
    const preview = document.createElement("div");
    preview.className = "card bg-base-100 shadow-xl relative";
    preview.dataset.fileIndex = index;
    preview.innerHTML = `
      <figure>
        <img class="h-auto w-44 rounded-md object-cover pt-10" src="${dataUrl}">
      </figure>
      <div class="card-actions justify-end">
        <button type="button"
                class="hover:bg-primary-dark absolute right-0 top-0 rounded-full bg-primary text-white"
                data-action="click->image-upload#removePreview">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
          <path stroke-linecap="round" stroke-linejoin="round" d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
        </svg>
        </button>
      </div>
    `;
    this.previewContainerTarget.appendChild(preview);
  }

  clearPreviews() {
    this.previewContainerTarget.innerHTML = "";
    this.selectedFiles = new DataTransfer();
    this.inputTarget.files = this.selectedFiles.files;
  }

  removePreview(event) {
    event.preventDefault();
    const card = event.target.closest(".card");

    if (!card) return;

    const fileIndex = parseInt(card.dataset.fileIndex);

    // Create new DataTransfer object
    const newFiles = new DataTransfer();

    // Add all files except the one being removed
    Array.from(this.selectedFiles.files).forEach((file, index) => {
      if (index !== fileIndex) {
        newFiles.items.add(file);
      }
    });

    // Update our stored files
    this.selectedFiles = newFiles;
    // Update the actual input
    this.inputTarget.files = this.selectedFiles.files;

    this.submitButtonTarget.disabled = this.selectedFiles.files.length === 0;

    // Remove the preview
    card.remove();

    // Update remaining preview indices
    this.previewContainerTarget
      .querySelectorAll(".card")
      .forEach((preview, index) => {
        preview.dataset.fileIndex = index;
      });
  }

  async submit(event) {
    event.preventDefault();

    this.submitButtonTarget.disabled = true;
    this.submitButtonTarget.classList.add("hidden");
    this.spinnerTarget.classList.remove("hidden");

    try {
      const data = await api.uploadFiles(
        "/images",
        Array.from(this.inputTarget.files),
        { target: `${this.modelNameValue}-images` },
      );

      // Close modal
      this.element.querySelector('[data-action*="modal#close"]').click();
    } catch (error) {
      this.submitButtonTarget.disabled = false;
      this.submitButtonTarget.classList.remove("hidden");
      this.spinnerTarget.classList.add("hidden");
      console.error("Upload failed:", error);
    }
  }
}
